import React, { Fragment, useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import InputMask from "react-input-mask";
import es from "date-fns/locale/es";
import moment from "moment";
import { v4 as uuid } from "uuid";
import { defaultIcon } from "./icons";

registerLocale("es", es);

const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const InputPicker = ({
  id = uuid(),
  onChange,
  onBlur = null,
  onkeydown = null,
  disabled = false,
  className = "",
  label = "",
  value = null,
  maxDate = null,
  minDate = null,
  mask = "99/99/9999",
  formatPicker = "DD-MM-YYYY",
  icon = defaultIcon,
  hasError = null, // ENVIAR UN TEXTO O COMPONENTE
  untilToday = false,
  showMonthYearPicker = false,
  placeholder="dd/mm/aaaa"
}) => {
  const [maskValue, setMaskValue] = useState(null);
  const [editable, setEditable] = useState(false);

  const onChangeMask = (event) => {
    const valueMask = event.target.value;

    setEditable(true);
    setMaskValue(valueMask);

    if ((valueMask || "").trim().length === 0) {
      onChange({ value: null, hasErrorFormat: false });
      return;
    }

    if (!valueMask.includes("_")) {
      const splitDate = valueMask.split("/");
      let temp;
      if(mask=='99/99/9999')
        temp = new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`);
      if(mask=='9999/99')
        temp = new Date(`${splitDate[1]}/${'01'}/${splitDate[0]}`);

      if (moment(temp).isValid()) {
        const today = new Date();
        if (untilToday && moment(temp) > today) {
          onChange({ value: temp, hasErrorFormat: true });
          return;
        }
        onChange({ value: temp, hasErrorFormat: false });
        return;
      }
    }
    onChange({ value: null, hasErrorFormat: true });
  };

  useEffect(() => {
    if (
      !editable &&
      moment(value).isValid() &&
      moment(value).format(formatPicker) !== maskValue
    ) {
      setMaskValue(moment(value).format(formatPicker));
    }
  }, [value]);

  return (
    <Fragment>
      <div
        id={id}
        className={`rd--input rd--input--picker active filled ${
          hasError ? "has-error" : ""
        } ${disabled ? "disabled" : ""} ${className}`.trim()}
        disabled={disabled}
      >
        <label>{label}</label>
        <InputMask
          placeholder={placeholder}
          mask={mask}
          onChange={onChangeMask}
          value={maskValue || ""}
          onClick={() => setEditable(true)}
          onBlur={() => {
            setEditable(false);
            if (onBlur) {
              onBlur();
            }
          }}
          onKeyDown ={onkeydown}
        />
        <DatePicker
          showMonthYearPicker = {showMonthYearPicker}
          locale="es"
          selected={value}
          onChange={(valueDay) =>
            onChange({ value: valueDay, hasErrorFormat: false })
          }
          maxDate={maxDate}
          minDate={minDate}
          customInput={<button>{icon}</button>}
          /*renderCustomHeader={({
            date,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div className="rd--custom__head_year">
              <button
                className="rd--arrow rd--left--date"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7468 12.7613C10.4177 13.0796 9.88996 13.0796 9.56087 12.7613L5.25318 8.5946C4.91561 8.26808 4.91561 7.73192 5.25318 7.4054L9.56087 3.23874C9.88996 2.92042 10.4177 2.92042 10.7468 3.23874C11.0844 3.56526 11.0844 4.10141 10.7468 4.42793L7.05385 8L10.7468 11.5721C11.0844 11.8986 11.0844 12.4347 10.7468 12.7613Z"
                    fill="#EF3340"
                  />
                </svg>
              </button>
              <label>{`${
                months[date.getMonth()]
              } ${date.getFullYear()}`}</label>
              <button
                className="rd--arrow rd--right--date"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25318 3.23874C5.58227 2.92042 6.11004 2.92042 6.43913 3.23874L10.7468 7.4054C11.0844 7.73192 11.0844 8.26808 10.7468 8.5946L6.43913 12.7613C6.11004 13.0796 5.58227 13.0796 5.25318 12.7613C4.91561 12.4347 4.91561 11.8986 5.25318 11.5721L8.94615 8L5.25318 4.42793C4.91561 4.10141 4.91561 3.56526 5.25318 3.23874Z"
                    fill="#EF3340"
                  />
                </svg>
              </button>
            </div>
          )}*/
        />
      </div>
      {hasError ? (
        <span className="rd--input-error" htmlFor={id}>
          {hasError}
        </span>
      ) : null}
    </Fragment>
  );
};

export default InputPicker;
